import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import axiosInstance from '../axiosInterceptor'
import { toast } from 'react-toastify'

const AddMenu = () => {
    const navigator = useNavigate();
    const location = useLocation();
    const editData = location.state

    const [menuData, setMenuData] = useState([]);

    const [data, setData] = useState({
        parentMenuId: editData?.parentMenuId || '', // Initialize with editData?.parentMenuId or a default value
        menuName: editData?.menuName || '',
        menuUrl: editData?.menuUrl || '',
        position: editData?.position || '',
        isActive: editData?.isActive || false
    });

    const [errors, setErrors] = useState({
        position: '',
        menuName: '',
        // parentMenuId: '',
        menuUrl: '',
    });

    const handleChange = (e) => {
        const { name, checked, value } = e.target;
        if (name === "isActive") {
            setData({ ...data, [name]: checked });
        } else {
            setData({ ...data, [name]: value });
        }
        setErrors({ ...errors, [name]: '' });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        let hasErrors = false;

        if (!data.position.trim()) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                position: 'Position is required'
            }));
            hasErrors = true;
        }
        if (!data.menuName) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                menuName: 'Menu name is required'
            }));
            hasErrors = true;
        }
        if (!data.menuUrl) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                menuUrl: 'Menu url is required'
            }));
            hasErrors = true;
        }
        // if (!data.parentMenuId) {
        //     setErrors((prevErrors) => ({
        //         ...prevErrors,
        //         parentMenuId: 'Parent menu is required'
        //     }));
        //     hasErrors = true;
        // }
        // If there are errors, stop further processing
        if (hasErrors) {
            return;
        }

        try {
            const response = await axiosInstance.post(`menu/createMenu`, data);
            if (response.status === 200) {
                toast.success(response.data.message);
                navigator("/menu");
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        }
    };
    const handleUpdate = async (e) => {
        e.preventDefault();

        try {
            const response = await axiosInstance.put(`menu/updateMenu/${editData?._id}`, data);
            if (response.status === 200) {
                toast.success(response.data.message);
                navigator("/menu");
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        }
    };

    const fetchData = async () => {
        try {
            const response = await axiosInstance.get(`menu/getParentMenu`);
            const { data } = response.data;
            setMenuData(data);
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        }
    };

    useEffect(() => {
        fetchData();
    }, []);
    return (
        <>
            <div className="content-wrapper">
                <div className="page-header mt-5 mx-4">
                    <h3 className="page-title">Add Menu </h3>
                </div>
                <div className="col-md-12 grid-margin stretch-card">
                    <div className="col-md-8  ">
                        <div className="card">
                            <div className="card-body">
                                <form className="pt-3" onSubmit={editData?._id ? handleUpdate : handleSubmit}>
                                    <div className="form-group row">
                                        <label for="exampleInputUsername2" className="col-sm-3 col-form-label">Parent Menu</label>
                                        <div className="col-sm-9">
                                            <select
                                                className="form-control form-control-lg"
                                                id="parentMenuId"
                                                name='parentMenuId'
                                                onChange={handleChange}
                                            >
                                                <option value="-">-- Root --</option>
                                                {menuData?.map(menuItem => (
                                                    <option key={menuItem._id} value={menuItem._id}>{menuItem.menuName}</option>
                                                ))}
                                            </select>

                                            {/* {errors.parentMenuId && <p className="text-danger">{errors.parentMenuId}</p>} */}
                                        </div>

                                    </div>

                                    <div className="form-group row">
                                        <label
                                            for="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Position
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="number"
                                                className="form-control form-control-sm"
                                                id="position"
                                                name="position"
                                                placeholder="Enter position"
                                                value={data.position}
                                                onChange={handleChange}
                                            />
                                            {errors.position && <p className="text-danger">{errors.position}</p>}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            for="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Menu Name
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="menuName"
                                                name="menuName"
                                                placeholder="Enter menu name"
                                                value={data.menuName}
                                                onChange={handleChange}
                                            />
                                            {errors.menuName && <p className="text-danger">{errors.menuName}</p>}
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label
                                            for="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Menu Url
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="menuUrl"
                                                name="menuUrl"
                                                placeholder="Enter menu url"
                                                value={data.menuUrl}
                                                onChange={handleChange}
                                            />
                                            {errors.menuUrl && <p className="text-danger">{errors.menuUrl}</p>}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            for="exampleInputUsername2"
                                            className="col-sm-3 "
                                        >Is Active
                                        </label>
                                        <div className="col-sm-9">
                                            <div className="custom-control custom-switch">
                                                <input
                                                    type="checkbox" className="custom-control-input"
                                                    name='isActive'
                                                    id="isActiveSwitch"
                                                    checked={data.isActive}
                                                    onChange={(e) => handleChange(e)} />
                                                <label className="custom-control-label " for="isActiveSwitch">{data.isActive === true ? "Active" : "Deactive"}</label>

                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-3 col-form-label"></label>
                                                <div className="col-sm-9">

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='text-center'>
                                        <Link to="/menu"><button className="btn btn-secondary mr-2">
                                            Back </button></Link>
                                        <button type="submit" className="btn btn-success">
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddMenu;